'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

exports.default = configureStore;

var _redux = require('redux');

var _reduxThunk = require('redux-thunk');

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _middleware = require('redux-saga/lib/internal/middleware');

var _middleware2 = _interopRequireDefault(_middleware);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// # 构建Redux的状态容器

/**
 * + redux的middleware，让dispatch支持actionCreator
 * > see: https://www.npmjs.com/package/redux-thunk
 */
function configureStore() {
  var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var middlewares = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var reducerFactory = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {
    return {};
  };
  var callback = arguments[3];

  var rootReducer = reducerFactory();

  var sagaMiddleware = (0, _middleware2.default)();

  var enhancer = (0, _redux.compose)(_redux.applyMiddleware.apply(undefined, [_reduxThunk2.default, sagaMiddleware].concat((0, _toConsumableArray3.default)(middlewares))));

  var store = (0, _redux.createStore)(rootReducer, initialState, enhancer);
  store.runSage = sagaMiddleware.run;
  callback && callback(store);

  return store;
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/seed/store/store.prod.js
// module id = 154
// module chunks = 0